import { render, staticRenderFns } from "./CorrelationArrows.vue?vue&type=template&id=5056d596"
import script from "./CorrelationArrows.vue?vue&type=script&lang=ts"
export * from "./CorrelationArrows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports